import { render } from "./NDIView.vue?vue&type=template&id=0255007c&scoped=true&ts=true"
import script from "./NDIView.vue?vue&type=script&lang=ts"
export * from "./NDIView.vue?vue&type=script&lang=ts"

import "./NDIView.vue?vue&type=style&index=0&id=0255007c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0255007c"]])

export default __exports__